module.exports = __webpack_public_path__ + "static/media/avive_appuser_accepted_hover.5e4ff5a1.svg";